// Mock data for Shadow Path Services clone (frontend-only)

export const contact = {
  phone: "(786) 920-2715",
  phoneRaw: "7869202715",
  email: "info@shadowpathservices.com",
  city: "Miami, FL, USA",
  instagram: "https://www.instagram.com/shadowpathservices",
  whatsapp: "https://wa.me/17869202715?text=Hi%20Shadow%20Path%2C%20I%20have%20a%20question%20before%20booking",
};

export const heroImage = "/fleet/night2.png";

export const chauffeurImage =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_shadowpath-next/artifacts/kro3j67c_DSC03388.webp";

export const services = [
  {
    id: "airport-transfer",
    title: "Airport Transfer",
    tagline: "Effortless and Luxurious",
    short:
      "Arrive or depart in comfort and style with our punctual, hassle-free luxury airport service.",
    long:
      "Skip the stress of airport logistics. Our chauffeurs track your flight in real time, greet you at arrivals, and handle your luggage — so you glide from terminal to Escalade without lifting a finger. Perfect for MIA, FLL and private terminals.",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_shadowpath-next/artifacts/8bdjgmj2_DSC_6227.webp",
    price: "",
  },
  {
    id: "corporate",
    title: "Corporate Services",
    tagline: "Tailored Solutions for Businesses",
    short:
      "Impress clients and travel stress-free with our discreet, professional chauffeur service.",
    long:
      "Executive transportation built for business. Discreet, punctual, and impeccably presented — ideal for client roadshows, board meetings and airport runs. Corporate accounts and monthly billing available.",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_shadowpath-next/artifacts/kseud5rj_DSC03405.webp",
    price: "",
  },
  {
    id: "special-events",
    title: "Special Event Transport",
    tagline: "Memorable Transportation Experience",
    short:
      "Weddings, galas, VIP events—arrive in elegance with our premium fleet.",
    long:
      "Make an entrance worthy of the occasion. From weddings and galas to premieres and proms, our blacked-out fleet and white-glove chauffeurs deliver a red-carpet arrival every time.",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_shadowpath-next/artifacts/nbmlz4pf_DSC03416.webp",
    price: "",
  },
  {
    id: "hourly",
    title: "Hourly Rate Service",
    tagline: "Your Schedule, Our Service",
    short:
      "Flexible, on-demand luxury transportation for meetings, sightseeing, or errands.",
    long:
      "Keep your chauffeur and Escalade on call for the day. Ideal for multi-stop meetings, shopping, sightseeing across Miami, or nights out — total flexibility, one seamless rate.",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_shadowpath-next/artifacts/gxfjdqxh_DSC_6219.webp",
    price: "$150/hr",
    note: "3 hr minimum",
  },
];

export const safeRide = {
  title: "Shadow Path SafeRide",
  subtitle: "Luxury Pickup & Car Return Service",
  heroImage: "/fleet/night1.png",
  toastImage:
    "https://images.unsplash.com/photo-1705944601076-ffa84903c6cb",
  benefits: [
    "Enjoy your night without worrying about driving.",
    "We pick you up in a luxury Escalade.",
    "A second driver returns your car safely to your location.",
    "Discreet, professional, and reliable service.",
    "Perfect for nightlife, events, or special occasions.",
  ],
  steps: [
    { icon: "Car", text: "Pickup in a luxury Escalade" },
    { icon: "Users", text: "A second driver returns your car safely" },
    { icon: "ShieldCheck", text: "Discreet, reliable service for late nights & events" },
  ],
};

export const luxuryAddOns = [
  {
    id: "champagne",
    title: "Champagne & Cooler",
    desc: "Indulge with our selection of Moët & Chandon champagne coupons and a chilled cooler to add sophistication to your ride.",
    image:
      "https://images.unsplash.com/photo-1643618829236-a23857519fb6?crop=entropy&cs=srgb&fm=jpg&q=85",
    price: "$75",
  },
  {
    id: "roses",
    title: "Fresh Roses",
    desc: "Make a statement with a fresh bouquet of roses. Choose from 24, 50, 75, 100, or 125 roses to customize your experience.",
    image:
      "https://images.unsplash.com/photo-1559779080-6970e0186790?crop=entropy&cs=srgb&fm=jpg&q=85",
    price: "from $60",
  },
  {
    id: "red-carpet",
    title: "Red Carpet Service",
    desc: "Experience VIP treatment with our red-carpet roll-out service for a grand, unforgettable entrance.",
    image:
      "https://images.pexels.com/photos/7594122/pexels-photo-7594122.jpeg?auto=compress&cs=tinysrgb&w=940",
    price: "$50",
  },
  {
    id: "welcome-board",
    title: "Personalized Welcome Board",
    desc: "Custom LED board in your vehicle with your name, message, or event details for a warm, exclusive touch.",
    image:
      "https://images.unsplash.com/photo-1533106497176-45ae19e68ba2?crop=entropy&cs=srgb&fm=jpg&q=85",
    price: "$25",
  },
  {
    id: "birthday",
    title: "Birthday Package",
    desc: "Festive ride upgrade with balloons, welcome board, and a Moët & Chandon coupon. Perfect for celebrations.",
    image:
      "https://images.unsplash.com/photo-1695649912699-435a5bc20203?crop=entropy&cs=srgb&fm=jpg&q=85",
    price: "$120",
  },
  {
    id: "giant-bear",
    title: "Giant Bear",
    desc: "A 4ft plush teddy bear surprise in your vehicle — huggable fun for birthdays or romance. Sanitized and photo-ready.",
    image:
      "https://images.unsplash.com/photo-1559779080-6970e0186790?crop=entropy&cs=srgb&fm=jpg&q=85",
    price: "$90",
  },
  {
    id: "romance",
    title: "Signature Romance Package",
    desc: "Silk rose petals, a plush teddy bear, soft ambient lighting, a Moët & Chandon coupon, and a personalized welcome board — perfect for proposals and anniversaries.",
    image:
      "https://images.unsplash.com/photo-1643734390541-4715912ba3cb?crop=entropy&cs=srgb&fm=jpg&q=85",
    price: "$220",
  },
  {
    id: "rose-glow",
    title: "Rose Petal & Glow Experience",
    desc: "A delicate scattering of premium silk rose petals throughout the cabin with soft ambient LED candles — romantic without the clutter.",
    image:
      "https://images.unsplash.com/photo-1643734390541-4715912ba3cb?crop=entropy&cs=srgb&fm=jpg&q=85",
    price: "$110",
  },
  {
    id: "chocolates",
    title: "Box of Chocolates",
    desc: "A sweet touch of luxury — a Ferrero Rocher heart-shaped chocolate box that pairs perfectly with your journey.",
    image:
      "https://images.unsplash.com/photo-1695649912699-435a5bc20203?crop=entropy&cs=srgb&fm=jpg&q=85",
    price: "$35",
  },
];

export const testimonials = [
  {
    name: "Alexandra R.",
    role: "Corporate Client",
    text: "Flawless from booking to drop-off. The Escalade was immaculate and my chauffeur was early, discreet, and professional. My go-to in Miami.",
    rating: 5,
  },
  {
    name: "Marcus T.",
    role: "SafeRide Guest",
    text: "SafeRide is genius. We enjoyed the night out and they returned my car home safely. Total peace of mind — pure class.",
    rating: 5,
  },
  {
    name: "Sofia & Daniel",
    role: "Wedding",
    text: "They rolled out the red carpet — literally. Rose petals, champagne, and a spotless ride. Our arrival was unforgettable.",
    rating: 5,
  },
];

export const stats = [
  { value: "24/7", label: "Availability" },
  { value: "5.0", label: "Average Rating" },
  { value: "100%", label: "Licensed & Insured" },
  { value: "3k+", label: "Rides Completed" },
];

export const faqs = [
  {
    q: "What areas do you serve?",
    a: "We operate throughout Miami-Dade, Broward and surrounding areas, including MIA and FLL airports, PortMiami, and long-distance trips on request.",
  },
  {
    q: "What vehicles are in your fleet?",
    a: "Our signature fleet features blacked-out Cadillac Escalade and Escalade ESV SUVs — immaculately detailed, with premium leather interiors and complimentary water.",
  },
  {
    q: "How does Shadow Path SafeRide work?",
    a: "We pick you up in a luxury Escalade while a second professional driver follows and returns your own car safely to your location — ideal for nights out and events.",
  },
  {
    q: "How far in advance should I book?",
    a: "We recommend booking at least 24 hours ahead to guarantee availability, but we also accommodate last-minute requests based on fleet availability — just call us.",
  },
  {
    q: "Can I add champagne, roses, or other extras?",
    a: "Absolutely. Browse our Luxury Add-Ons — from Moët & Chandon and fresh roses to red-carpet service and our Signature Romance Package — and select them during booking.",
  },
  {
    q: "Are your chauffeurs licensed and insured?",
    a: "Yes. Every chauffeur is fully licensed, background-checked, and insured, and each vehicle carries commercial coverage for your complete peace of mind.",
  },
  {
    q: "What is your cancellation policy?",
    a: "Cancellations made at least 12 hours before pickup receive a full refund. Later cancellations may incur a fee. See our Cancellation Policy for full details.",
  },
  {
    q: "How do I pay?",
    a: "We accept all major credit cards and digital payments. Corporate accounts with monthly invoicing are available on request.",
  },
];

// Booking service types (card selector) — only Hourly Rental is priced.
export const serviceTypes = [
  {
    id: "hourly-rental",
    title: "Hourly Rental",
    desc: "Rent by the hour for maximum flexibility",
    note: "Minimum 3 hours",
    icon: "Hourglass",
    priced: true,
  },
  {
    id: "one-way",
    title: "One-Way",
    desc: "Simple destination drop-off",
    icon: "MoveRight",
    priced: false,
  },
  {
    id: "round-trip",
    title: "Round Trip",
    desc: "We drive you there and back",
    icon: "RefreshCw",
    priced: false,
  },
  {
    id: "airport-transfer",
    title: "Airport Transfer",
    desc: "Door-to-door airport service",
    icon: "Ticket",
    priced: false,
  },
  {
    id: "saferide",
    title: "Shadow Path SafeRide",
    desc: "Luxury pickup & safe car return",
    icon: "ShieldCheck",
    priced: false,
  },
];

// Pricing (kept in sync with backend). Only Hourly Rental is charged.
export const HOURLY_RATE = 150;
export const MIN_HOURS = 3;

export const addOnPrices = {
  champagne: 75,
  roses: 60,
  "red-carpet": 50,
  "welcome-board": 25,
  birthday: 120,
  "giant-bear": 90,
  romance: 220,
  "rose-glow": 110,
  chocolates: 35,
};

export const computeQuote = (service, hours, addOns = []) => {
  const addonsTotal = addOns.reduce((sum, id) => sum + (addOnPrices[id] || 0), 0);
  if (service === "Hourly Rental") {
    const h = Math.max(MIN_HOURS, parseInt(hours, 10) || MIN_HOURS);
    const ride = h * HOURLY_RATE;
    return { priced: true, hours: h, ridePrice: ride, addonsTotal, total: ride + addonsTotal };
  }
  return { priced: false, hours: 0, ridePrice: null, addonsTotal, total: addonsTotal };
};

export const legalContent = {
  terms: {
    title: "Terms and Conditions",
    intro:
      "By booking with Shadow Path Services you agree to the following terms. Please read them carefully.",
    sections: [
      { h: "Bookings", p: "All bookings are subject to fleet availability and confirmation. Quoted rates are estimates until confirmed in writing." },
      { h: "Conduct", p: "Guests are expected to treat our vehicles and chauffeurs with respect. Any damage caused may incur cleaning or repair charges." },
      { h: "Liability", p: "While we take every care, Shadow Path Services is not liable for delays caused by traffic, weather, or events outside our control." },
      { h: "Payment", p: "Full payment or an authorized hold is required to confirm your reservation. Add-ons are billed with the base fare." },
    ],
  },
  cancellation: {
    title: "Cancellation Policy",
    intro: "We understand plans change. Our cancellation policy is designed to be fair.",
    sections: [
      { h: "Full Refund", p: "Cancel at least 12 hours before your scheduled pickup for a 100% refund." },
      { h: "Partial Charge", p: "Cancellations within 12 hours of pickup may be charged 50% of the fare." },
      { h: "No-Show", p: "Failure to appear at the pickup point without notice will be charged the full fare." },
      { h: "Add-Ons", p: "Perishable add-ons (roses, champagne, chocolates) are non-refundable once prepared." },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    intro: "Your privacy and discretion are central to our service.",
    sections: [
      { h: "Information We Collect", p: "We collect only the details needed to fulfil your booking — name, contact information, pickup/drop-off, and preferences." },
      { h: "How We Use It", p: "Your data is used solely to provide and improve our service. We never sell your information." },
      { h: "Discretion", p: "Chauffeurs are held to strict confidentiality. What happens in the Escalade stays in the Escalade." },
      { h: "Security", p: "Payment and personal data are handled securely and retained only as long as necessary." },
    ],
  },
};
